
;( function( $, window, document, options ) {

	"use strict";

		
		var pluginName = "clickZoom",
			defaults = {
			    active: true,
			    zoomLimit: 3
			};

		function Plugin ( element, options ) {
			this.element = element;

			this.settings = $.extend( {}, defaults, options );
			this._defaults = defaults;
			this._name = pluginName;
			this.init(); 
		}

		$.extend(Plugin.prototype, {
		    val1: 1,
		    val2: 0,
		    init: function () {
		        this.setSize();
		        this.onResize();
		        $(this.element).bind("click",this.ImageClick);
		    },
		    onResize:function(){
		        $(window).on("resize", function () {
		            console.log("resize");
		        });
		    },
		    setSize: function () {

		        var that = this;

		        $("<img/>")
                .attr("src", $(that.element).find("img").attr("src"))
                .load(function () {
                    $(that.element).parent().height(this.height);
                    $(that.element).parent().width(this.width);
                    $(that.element).parent().css('display', 'inline-block');
                    $(that.element).parent().css('overflow', 'hidden');
                    $(that.element).find("img").attr("data-zv",0);

                    $(that.element).find("img").on("click", function (e) {
                        that.val2 = $(that.element).find("img").attr("data-zv"),
                        that.val2 = parseInt(that.val2) + 1;
                        console.log(that.val2);
                        that.zoomVal(that.val1 + "." + that.val2);
                        $(that.element).find("img").attr("data-zv", that.val2)
                    });
                });
			},
		    zoomVal: function (value) {
                var that = this;
		        $(that.element).find("img").css('zoom',value);
		    }

		});

		$.fn[pluginName] = function( options ) {
			return this.each( function() {
				if ( !$.data( this, "plugin_" + pluginName ) ) {
					$.data( this, "plugin_" +
						pluginName, new Plugin( this, options ) );
				}
			} );
		};

})(jQuery, window, document);
